import React from 'react';
import { getPrimary, getSecondary } from '../../styles/colors';
import {
	AlertConfirm, BasicButton, Radio, TextInput
} from '../../UI';

const ModalEditInput = ({
	translate,
	setLocalState,
	input,
	isDuplicatedName,
	label,
}) => {
	const [newMain, setNewMain] = React.useState(false);
	const [newInput, setNewInput] = React.useState(input);
	const [error, setError] = React.useState({});

	React.useEffect(() => {
		setNewInput(input);
	}, [input]);

	const emptyError = 'El valor no puede estar vacío';
	const duplicatedError = 'El valor ya está en uso';
	const incorrectValueError = 'El valor es incorrecto';
	const maxLessThanMinError = 'El valor no puede ser menor al mínimo';
	const minMoreThanMaxError = 'El valor no puede ser mayor al máximo';

	const valueTypes = [
		{
			label: 'Texto',
			value: 'text'
		},
		{
			label: 'Numero',
			value: 'number'
		},
		{
			label: 'Booleano',
			value: 'boolean'
		},
	];

	const setName = name => {
		setNewInput({
			...newInput,
			name
		});
		// Empty name
		if (!name) {
			setError({
				...error,
				name: emptyError
			});
			return;
		}
		// Duplicated name
		if (isDuplicatedName(name)) {
			setError({
				...error,
				name: duplicatedError
			});
			return;
		}
		const newError = error;
		delete newError.name;
		setError(newError);
	};

	const setMaxSelections = maxSelections => {
		setNewInput({
			...newInput,
			maxSelections
		});
		// Empty name
		if (maxSelections < 1) {
			setError({
				...error,
				maxSelections: incorrectValueError
			});
			return;
		}
		// Max selections is less than min selections
		if (maxSelections < newInput?.minSelections) {
			setError({
				...error,
				maxSelections: maxLessThanMinError
			});
			return;
		}
		const newError = error;
		delete newError.maxSelections;
		setError(newError);
	};

	const setMinSelections = minSelections => {
		setNewInput({
			...newInput,
			minSelections
		});
		// Empty name
		if (minSelections < 1) {
			setError({
				...error,
				maxSelections: incorrectValueError
			});
			return;
		}
		// Min selections is more than max selections
		if (minSelections > newInput?.maxSelections) {
			setError({
				...error,
				maxSelections: minMoreThanMaxError
			});
			return;
		}
		const newError = error;
		delete newError.maxSelections;
		setError(newError);
	};

	const setValue = value => {
		// Number type
		if (newInput?.valueType === 'number') {
			setNewInput({
				...newInput,
				value: parseFloat(value)
			});
			return;
		}
		// Boolean types
		if (newInput?.valueType === 'boolean' && value === 'true') {
			setNewInput({
				...newInput,
				value: true
			});
			return;
		}
		if (newInput?.valueType === 'boolean' && value === 'false') {
			setNewInput({
				...newInput,
				value: false
			});
			return;
		}
		setNewInput({
			...newInput,
			value
		});
	};

	return (
		<div style={{
			marginLeft: '1em',
		}}>
			<BasicButton
				color='white'
				text={label}
				onClick={() => setNewMain(true)}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold',
					height: '30px',
					width: '145px',
				}}
			/>
			<AlertConfirm
				open={newMain}
				title={'Valores de la opcion'}
				buttonAccept={translate.save}
				buttonCancel={translate.cancel}
				cancelAction={() => {
					setNewInput(input);
					setNewMain(false);
				}}
				hideAccept={Object.keys(error).length > 0}
				acceptAction={() => {
					setLocalState({ ...newInput });
					setNewMain(false);
				}}
				requestClose={() => setNewMain(true)}
				bodyStyle={{ minWidth: '60vw' }}
				bodyText={
					<div
						style={{
							display: 'flex', flexDirection: 'column', rowGap: '1em'
						}}
					>
						{/* INPUT NAME */}
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Nombre del campo
							</span>
							<TextInput
								floatingText={'Nombre'}
								onChange={event => setName(event.nativeEvent.target.value)}
								errorText={error.name}
								value={newInput.name}
							/>
						</div>
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Tipo de valor
							</span>
							<br/>
							{/* VALUE TYPE */}
							{valueTypes
							&& <div
								style={{
									display: 'flex', justifyContent: 'space-evenly'
								}}
							>
								{valueTypes.map(valueType => (
									<Radio
										key={valueType.value}
										styleLabel={{ margin: '0' }}
										name="valueType"
										label={valueType.label}
										value={valueType.value}
										checked={newInput?.valueType === valueType.value}
										onChange={event => setNewInput({
											...newInput,
											valueType: event.target.value
										})}
									/>
								))}
							</div>}
						</div>
						{/* DEFAULT VALUE */}
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Valor inicial
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setValue(event.nativeEvent.target.value)}
								value={newInput.value}
							/>
						</div>
						{/* OPTIONAL CHECKBOX OPTIONS */}
						{newInput.type === 'checkbox'
						&& <div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Opciones mínimas seleccionadas
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setMinSelections(parseFloat(event.nativeEvent.target.value))}
								errorText={error?.minSelections}
								value={newInput.minSelections}
							/>
						</div>}
						{newInput.type === 'checkbox'
						&& <div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Opciones máximas seleccionadas
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setMaxSelections(parseFloat(event.nativeEvent.target.value))}
								errorText={error?.maxSelections}
								value={newInput.maxSelections}
							/>
						</div>}
					</div>
				}
			/>
		</div>
	);
};


export default ModalEditInput;

